import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect, useDispatch } from "react-redux";
import Image from "next/image";
import Select from "react-select";
import { FaArrowRight } from "react-icons/fa";
import { useRouter } from "next/router";
import ChooseCarMobile from "../common/ChooseCarMobile";
import { fetchBrandObServe } from "../../actions/homePage";
import LazyLoad from "react-lazyload";

const Brands = ({ apiData, globalData }) => {
  const [brandList1, setBrandList1] = useState([]);
  const [brandList2, setBrandList2] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [showCarSelect, setShowCarSelect] = useState(false);
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    dispatch(fetchBrandObServe())
  }, []);

  useEffect(() => {
    var half_length = Math.ceil(apiData.homeBrands.length / 2);
    var leftSide = apiData.homeBrands.slice(0, half_length);
    var rightSide = apiData.homeBrands.slice(half_length);

    setBrandList1(rightSide);
    setBrandList2(leftSide);
    let cars = apiData.brands.map((car, index) => {
      return {
        label: car.Name,
        value: car.Slug,
        data: car,
      };
    });
    setIsLoading(false);
    setList(cars);
  }, [apiData.homeBrands, apiData.brands]);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    lazyload: true,
    cssEase: "linear",
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleBrandChange = (e) => {
    setSelectedBrand(e);
  };

  return (
    <div
      style={{ paddingRight: "4%", paddingLeft: "4%", marginBottom: "105px" }}
    >
      <img
        src="assets/images/bubble.webp"
        alt="bubble"
        // src={IMAGES.BUBBLE}
        style={{ position: "absolute", left: 0 }}
      />
      <Container>
        <Row className="justify-content-between my-4">
          <div className="w-75">
            <div className="text-start title-anim">
              <div className="header-all">Car Brands We Serve</div>
            </div>
            <p
              className="subHead-all text-start text-primary"
              style={{ color: "#0451be" }}
            >
              Our multi-branded services are powered by not just specialist
              partner workshops but also OB’s own expert service advisors
            </p>
          </div>
          <div className="hide-in-mobile d-flex align-items-end justify-content-end w-25">
            <Select
              className="basic-single"
              classNamePrefix="select"
              isLoading={isLoading}
              isClearable
              isRtl={false}
              isSearchable
              options={list}
              placeholder="Search Brand"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  width: 200,
                }),
              }}
              // className="ml-2"
              onChange={handleBrandChange}
            />
            <button
              className="border-none bg-yellow ml-1 rounded px-2"
              style={{ height: 38, opacity: selectedBrand == null ? 0.6 : 1 }}
              disabled={selectedBrand == null}
              onClick={() => {
                localStorage.setItem("global_car_data", JSON.stringify(selectedBrand?.data))
                router.push(
                  `/services/${globalData.locationData?.data?.EmirateAreaSlug || "dubai"
                  }/oil-change/${selectedBrand.value}`
                )
              }
              }
            >
              <FaArrowRight />
            </button>
          </div>
          <div className="for-mobile mt-2" style={{ zIndex: 10 }}>
            <button className="border-none rounded bg-blue px-2 py-1" style={{ zIndex: 9 }} onClick={() => { setShowCarSelect(true) }}>Select Brand</button>
          </div>
        </Row>

        {apiData.homeBrands.length > 0 && (
          <>
            <Row>
              <Col lg={12}>
                <Slider {...settings}>
                  {brandList1?.map((brand, index) => (
                    <LazyLoad key={index}>
                      <Link
                        href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                          "dubai"
                          }/oil-change/${brand.Slug}`}
                      >
                        <a>
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "150px" }}
                          >
                            <div
                              className="brand-logo"
                              style={{ marginTop: "20px", marginBottom: "20px" }}
                            >
                              <div
                                style={{
                                  width: "70px",
                                  position: "relative",
                                  height: 70,
                                  // overflow: "hidden",
                                }}
                              >
                                <Image
                                  src={brand.ImgUrl}
                                  alt="Brand"
                                  layout="fill"
                                  objectFit="contain"
                                />
                              </div>
                              {/* <img src={brand.ImgUrl} width={70} /> */}
                            </div>
                          </div>
                        </a>
                      </Link>
                    </LazyLoad>
                  ))}
                </Slider>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Slider {...settings}>
                  {brandList2?.map((brand, index) => (
                    <LazyLoad key={index}>
                      <Link
                        href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                          "dubai"
                          }/oil-change/${brand.Slug}`}
                      >
                        <a>
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "150px" }}
                          >
                            <div
                              className="brand-logo"
                              style={{ marginTop: "20px", marginBottom: "20px" }}
                            >
                              <div
                                style={{
                                  width: "70px",
                                  position: "relative",
                                  height: 70,
                                  // overflow: "hidden",
                                }}
                              >
                                <Image
                                  src={brand.ImgUrl}
                                  alt="Brand"
                                  layout="fill"
                                  objectFit="contain"
                                />
                              </div>
                              {/* <img src={brand.ImgUrl} width={70} /> */}
                            </div>
                          </div>
                        </a>
                      </Link>
                    </LazyLoad>
                  ))}
                </Slider>
              </Col>
            </Row>
          </>
        )}
      </Container>
      <ChooseCarMobile show={showCarSelect} setShow={setShowCarSelect} />
    </div >
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    profile: state.profile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Brands);
